import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieRanking from './components/MovieRanking';
import LatestMovies from './components/LatestMovies';

const faqData = [
  {
    question: '星空影院的电影资源多久更新一次？',
    answer: '星空影院的电影资源实行院线同步更新机制。每当有最新影片在院线上映，我们的团队会在第一时间进行同步更新，确保您能及时观看到最新、最热的电影内容。热门电影榜单每日更新，为您推荐最受观众喜爱的影片。',
  },
  {
    question: '在星空影院观看电影需要付费吗？',
    answer: '星空影院目前提供完全免费的在线观影服务。您无需支付任何费用，无需注册会员，即可畅享海量高清电影资源。我们致力于为广大影迷提供最便捷、最优质的观影体验。',
  },
  {
    question: '为什么星空影院的视频播放不缓冲？',
    answer: '星空影院采用了先进的视频CDN加速技术和多节点服务器部署架构。我们的视频流媒体传输系统经过深度优化，能够根据您的网络状况自动调整清晰度，确保观看过程中流畅无卡顿，真正实现在线播放不缓冲。',
  },
  {
    question: '星空影院支持哪些设备观看？',
    answer: '星空影院全面支持多端观看体验。您可以在电脑（Windows/Mac）、平板（iPad/Android）、手机（iPhone/Android）等多种设备上畅享高清电影。我们的网站采用响应式设计，自动适配不同屏幕尺寸，确保最佳观影效果。',
  },
  {
    question: '如何快速找到我想看的电影？',
    answer: '星空影院提供了多种便捷的电影查找方式：您可以通过首页的"电影分类"导航按类型、地区浏览电影；通过"热播排行榜"了解当前最受欢迎的电影；使用搜索功能直接查找特定影片。所有电影都配有详细的信息和评分，助您快速做出选择。',
  },
];

export default function Home() {
  useEffect(() => {
    document.title = '星空影院 - 热播电影与院线电影同步 | 热门电影排行榜最新上映大全免费在线观看';
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <HeroSection />

        <CategoryNav />

        <MovieRanking />

        <LatestMovies />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500 mt-1">关于星空影院的常见疑问解答</p>
            </div>

            <div className="max-w-3xl mx-auto grid gap-3">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-100/80 border border-background-200/60 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-4 cursor-pointer hover:bg-background-200/30 transition-colors">
                    <span className="text-sm font-medium text-foreground-100 pr-4">{faq.question}</span>
                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-primary-500 hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-4 pb-4 text-sm text-foreground-400 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '星空影院',
            url: 'https://xingkongcinema.com/',
            description: '星空影院提供热播电影、热门电影在线观看，院线电影同步更新，最新上映影片一网打尽，电影排行榜实时推荐，高清视频不缓冲免费看。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://xingkongcinema.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}